export const aboutDetails = [
  {
    id: 1,
    name: "amaan lakhani",
    github: "https://github.com/alakhani5",
    linkedIn: "https://www.linkedin.com/in/amaanlakhani/",
    email: "amaan.lakhani5@gmail.com",
    image:
      "https://amaanlakhani.files.wordpress.com/2020/03/cropped-776184247.png",
  },
  {
    id: 2,
    name: "daniel jacobson",
    github: "https://github.com/danielyj98",
    linkedIn: "https://www.linkedin.com/in/danielj98/",
    email: "Danielyjacobson@gmail.com",
    image: "https://ca.slack-edge.com/T024FPYBQ-U03JTNGQS94-faff4a393660-512",
  },
  {
    id: 3,
    name: "evan forde barden",
    github: "https://github.com/evanfordebarden",
    linkedIn: "https://www.linkedin.com/in/evanfordebarden/",
    email: "evanbarden@gmail.com",
    image: "https://avatars.githubusercontent.com/u/16345392?v=4",
  },
  {
    id: 4,
    name: "nicholas angelopoulos",
    github: "https://github.com/NickyAngel",
    linkedIn: "https://www.linkedin.com/in/nickyangel/",
    email: "neangelopoulos@gmail.com",
    image: "https://avatars.githubusercontent.com/u/105730827?v=4",
  },
];
